<template>
  <div class="basic-home-page" :style="getStyle">
    <!-- 栏目 -->
    <Nav></Nav>
    <router-view style="min-height: calc(100vh - 184px);"/>
    <WebSiteInfo />
    <SideService @handleBackTop="handleBackTop"/>
  </div>
</template>

<script>
import Nav from "./components/Nav";
import WebSiteInfo from './components/WebSiteInfo'
import SideService from './components/SideService'

export default {
  name: "HomePage",
  components: {
    Nav,
    // FooterNav,
    WebSiteInfo,
    SideService
   },
  data() {
    return {};
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    getStyle() {
      if (this.$route.name === 'purchaseInfo' || this.$route.name === 'helpCenter'
        || this.$route.name === 'policy' || this.$route.name === 'companyInfo' || this.$route.name === 'communication') return {'backgroundColor': '#f2f2f2' }
      else return { 'backgroundColor': '#fff' }
    }
  },
  methods: {
    handleBackTop() {
      const startY = window.pageYOffset || document.documentElement.scrollTop;
      const endY = 0;
      const duration = 500; // 滚动动画时长，单位为毫秒

      const startTime = new Date().getTime();
      const scroll = () => {
        const currentTime = new Date().getTime();
        const time = Math.min(1, (currentTime - startTime) / duration);
        const easedTime = time * (2 - time);
        const currentY = startY + (endY - startY) * easedTime;
        window.scroll(0, currentY);
        if (time < 1) {
          requestAnimationFrame(scroll);
        }
      };
      requestAnimationFrame(scroll);
    }
  }
};
</script>

<style lang="less" scoped>
.basic-home-page {
  min-width: 1280px;
  height: 100vh;
  overflow-y: auto;
}
</style>
